// extracted by mini-css-extract-plugin
export default {"player":"MediaPlayer_player__9KqnN","video":"MediaPlayer_video__vth1L"};